<!-- Top Products Card -->
<div class="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm dark:shadow-slate-900/30 border border-gray-100 dark:border-slate-700">
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div class="flex items-center gap-2">
      <span class="text-2xl">🏆</span>
      <h3 class="text-lg font-bold text-gray-800 dark:text-gray-100">Top Produits</h3>
    </div>
    <span class="text-sm text-gray-500 dark:text-gray-400">Par CA</span>
  </div>

  <!-- Loading State -->
  @if (isLoading) {
    <div class="space-y-4">
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <div
          class="flex items-center gap-4 animate-pulse"
          >
          <div class="w-10 h-10 bg-gray-200 dark:bg-slate-700 rounded-xl"></div>
          <div class="flex-1">
            <div class="h-4 bg-gray-200 dark:bg-slate-700 rounded w-1/2 mb-2"></div>
            <div class="h-3 bg-gray-200 dark:bg-slate-700 rounded w-full"></div>
          </div>
          <div class="h-4 bg-gray-200 dark:bg-slate-700 rounded w-16"></div>
        </div>
      }
    </div>
  }

  <!-- Error State -->
  @if (error && !isLoading) {
    <div class="text-center py-8">
      <span class="text-3xl mb-2 block">⚠️</span>
      <p class="text-gray-500 dark:text-gray-400">{{ error }}</p>
    </div>
  }

  <!-- Products List -->
  @if (!isLoading && !error && products.length > 0) {
    <div class="space-y-4">
      @for (product of products; track product; let i = $index) {
        <div
          class="flex items-center gap-4 p-3 rounded-xl hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 cursor-pointer transition-colors group"
          (click)="onProductClick(product.productId)"
          >
          <!-- Rang -->
          <div
            class="w-8 h-8 flex items-center justify-center rounded-full font-bold text-sm"
        [ngClass]="{
          'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300': i === 0,
          'bg-gray-100 dark:bg-slate-800 text-gray-700 dark:text-gray-300': i === 1,
          'bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300': i === 2,
          'bg-gray-50 dark:bg-slate-900 text-gray-500 dark:text-gray-400': i > 2,
        }"
            >
            {{ i + 1 }}
          </div>
          <!-- Icon & Nom -->
          <div class="flex items-center gap-3 flex-1 min-w-0">
            <span class="text-2xl">{{ product.icon }}</span>
            <div class="flex-1 min-w-0">
              <p class="font-medium text-gray-800 dark:text-gray-100 truncate">
                {{ product.productName }}
              </p>
              <!-- Barre de progression -->
              <div class="mt-1 h-1.5 bg-gray-100 dark:bg-slate-800 rounded-full overflow-hidden">
                <div
                  class="h-full rounded-full transition-all duration-500"
              [ngClass]="
                i === 0
                  ? 'bg-gradient-to-r from-indigo-500 to-purple-500'
                  : 'bg-indigo-400'
              "
                  [style.width]="getBarWidth(product.percentOfTotal)"
                ></div>
              </div>
            </div>
          </div>
          <!-- Stats -->
          <div class="text-right">
            <p class="font-bold text-gray-900 dark:text-white">
              {{ formatCurrency(product.revenue) }}
            </p>
            <div class="flex items-center justify-end gap-1 text-xs">
              <span>{{ product.quantitySold }} vendus</span>
              <span [ngClass]="getTrendClass(product.trend)">
                {{ getTrendIcon(product.trend) }}
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Empty State -->
  @if (!isLoading && !error && products.length === 0) {
    <div
      class="text-center py-8"
      >
      <span class="text-4xl mb-2 block">📭</span>
      <p class="text-gray-500 dark:text-gray-400">Aucune vente pour cette période</p>
    </div>
  }
</div>
